import { translate } from '@/domains/core/localization/translate';
export const {
  freeDeliveryComplementaryInfos,
  breadcrumbsMobileTitle
} = translate({
  "freeDeliveryComplementaryInfos": "*Free shipping availability will depend on your postcode, this information will be available at checkout.",
  "breadcrumbsMobileTitle": "You are here:"
});